import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
import { Spritesheet, Texture } from "pixi.js";
export class UnboardingResourcePackage extends BundleResourcesPackage {
    public constructor() {
        super("UnboardingResourcePackage");
    }
    public get assets_views_unboarding_unboarding_0_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/unboarding/unboarding-0_1x.atlas.json");
    }
    public get assets_views_unboarding_renter_additional_background_png(): Texture {
        return this.assets_views_unboarding_unboarding_0_1x_atlas_json.textures["renter_additional_background.png"];
    }
    public get assets_views_unboarding_stars_bg_second_page_png(): Texture {
        return this.assets_views_unboarding_unboarding_0_1x_atlas_json.textures["stars_bg_second_page.png"];
    }
    public get assets_views_unboarding_side_light_png(): Texture {
        return this.assets_views_unboarding_unboarding_0_1x_atlas_json.textures["side_light.png"];
    }
    public get assets_views_unboarding_sequence_frame_png(): Texture {
        return this.assets_views_unboarding_unboarding_0_1x_atlas_json.textures["sequence_frame.png"];
    }
    public get assets_views_unboarding_owner_header_png(): Texture {
        return this.assets_views_unboarding_unboarding_0_1x_atlas_json.textures["owner_header.png"];
    }
    public get assets_views_unboarding_tokens_additional_png(): Texture {
        return this.assets_views_unboarding_unboarding_0_1x_atlas_json.textures["tokens_additional.png"];
    }
    public get assets_views_unboarding_selector_png(): Texture {
        return this.assets_views_unboarding_unboarding_0_1x_atlas_json.textures["selector.png"];
    }
    public get assets_views_unboarding_second_fragment_png(): Texture {
        return this.assets_views_unboarding_unboarding_0_1x_atlas_json.textures["second_fragment.png"];
    }
    public get assets_views_unboarding_third_fragment_png(): Texture {
        return this.assets_views_unboarding_unboarding_0_1x_atlas_json.textures["third_fragment.png"];
    }
    public get assets_views_unboarding_owner_profile_icon_png(): Texture {
        return this.assets_views_unboarding_unboarding_0_1x_atlas_json.textures["owner_profile_icon.png"];
    }
    public get assets_views_unboarding_renter_profile_icon_png(): Texture {
        return this.assets_views_unboarding_unboarding_0_1x_atlas_json.textures["renter_profile_icon.png"];
    }
    public get assets_views_unboarding_skip_button_png(): Texture {
        return this.assets_views_unboarding_unboarding_0_1x_atlas_json.textures["skip_button.png"];
    }
    public get assets_views_unboarding_unboarding_0_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/unboarding/unboarding-0_1x.atlas.png");
    }
    public get assets_views_unboarding_unboarding_1_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/unboarding/unboarding-1_1x.atlas.json");
    }
    public get assets_views_unboarding_stars_bg_third_page_png(): Texture {
        return this.assets_views_unboarding_unboarding_1_1x_atlas_json.textures["stars_bg_third_page.png"];
    }
    public get assets_views_unboarding_top_light_green_png(): Texture {
        return this.assets_views_unboarding_unboarding_1_1x_atlas_json.textures["top_light_green.png"];
    }
    public get assets_views_unboarding_yellow_side_light_png(): Texture {
        return this.assets_views_unboarding_unboarding_1_1x_atlas_json.textures["yellow_side_light.png"];
    }
    public get assets_views_unboarding_bottom_light_png(): Texture {
        return this.assets_views_unboarding_unboarding_1_1x_atlas_json.textures["bottom_light.png"];
    }
    public get assets_views_unboarding_rented_header_png(): Texture {
        return this.assets_views_unboarding_unboarding_1_1x_atlas_json.textures["rented_header.png"];
    }
    public get assets_views_unboarding_building_road_png(): Texture {
        return this.assets_views_unboarding_unboarding_1_1x_atlas_json.textures["building_road.png"];
    }
    public get assets_views_unboarding_token_with_separation_png(): Texture {
        return this.assets_views_unboarding_unboarding_1_1x_atlas_json.textures["token_with_separation.png"];
    }
    public get assets_views_unboarding_first_fragment_png(): Texture {
        return this.assets_views_unboarding_unboarding_1_1x_atlas_json.textures["first_fragment.png"];
    }
    public get assets_views_unboarding_adress_placeholder_png(): Texture {
        return this.assets_views_unboarding_unboarding_1_1x_atlas_json.textures["adress_placeholder.png"];
    }
    public get assets_views_unboarding_landlord_text_png(): Texture {
        return this.assets_views_unboarding_unboarding_1_1x_atlas_json.textures["landlord_text.png"];
    }
    public get assets_views_unboarding_unboarding_1_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/unboarding/unboarding-1_1x.atlas.png");
    }
    public get assets_views_unboarding_unboarding_2_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/unboarding/unboarding-2_1x.atlas.json");
    }
    public get assets_views_unboarding_top_light_purpule_png(): Texture {
        return this.assets_views_unboarding_unboarding_2_1x_atlas_json.textures["top_light_purpule.png"];
    }
    public get assets_views_unboarding_stars_bg_first_page_png(): Texture {
        return this.assets_views_unboarding_unboarding_2_1x_atlas_json.textures["stars_bg_first_page.png"];
    }
    public get assets_views_unboarding_piggy_png(): Texture {
        return this.assets_views_unboarding_unboarding_2_1x_atlas_json.textures["piggy.png"];
    }
    public get assets_views_unboarding_token_icon_png(): Texture {
        return this.assets_views_unboarding_unboarding_2_1x_atlas_json.textures["token_icon.png"];
    }
    public get assets_views_unboarding_coin_icon_png(): Texture {
        return this.assets_views_unboarding_unboarding_2_1x_atlas_json.textures["coin_icon.png"];
    }
    public get assets_views_unboarding_unboarding_2_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/unboarding/unboarding-2_1x.atlas.png");
    }
    public get assets_views_unboarding_unboarding_3_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/unboarding/unboarding-3_1x.atlas.json");
    }
    public get assets_views_unboarding_tokens_bg_png(): Texture {
        return this.assets_views_unboarding_unboarding_3_1x_atlas_json.textures["tokens_bg.png"];
    }
    public get assets_views_unboarding_buildings_png(): Texture {
        return this.assets_views_unboarding_unboarding_3_1x_atlas_json.textures["buildings.png"];
    }
    public get assets_views_unboarding_arrow_light_png(): Texture {
        return this.assets_views_unboarding_unboarding_3_1x_atlas_json.textures["arrow_light.png"];
    }
    public get assets_views_unboarding_unboarding_3_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/unboarding/unboarding-3_1x.atlas.png");
    }
}

